<template>
  <stats-card
    type="dangerDash"
    icon="nc-icon nc-bell-55"
    :title="snapshot.warning.length.toString(10)"
    :small-title="i18nValues['alerts']"
    v-if="snapshot.warning"
  >
    <div  slot="footer" style="height: 14px;">
      <el-tooltip placement="bottom" effect="light">
        <div slot="content" class="p-10">
          <el-table
            :data="snapshot.warning"
            class="table tableTooltip table-hover table-striped no-more-tables no-margin"
          >
            <el-table-column
              :formatter="formatDateHour"
              :label="i18nValues['dateAndTime']"
              align="center"
              width="130"
            />
            <el-table-column
              prop="dashboardCard"
              :label="i18nValues['type']"
              align="left"
              width="131"
            ></el-table-column>
            <el-table-column :label="i18nValues['message']" align="left">
              <template slot-scope="props">
                <el-tooltip effect="light" placement="top-start" :content="props.row.warningMessage" popper-class="dashboardInnerTooltip">
                  <span>{{props.row.warningMessage}}</span>
                </el-tooltip>  
                </template>
              </el-table-column>
            <el-table-column prop="hint" :label="i18nValues['help']" align="left"></el-table-column>
          </el-table>
        </div>
        <el-button
          class="btn-tooltip text-grey"
          size="small"
          icon="nc-icon nc-bookmark-2"
        >{{i18nValues['detail']}}</el-button>
      </el-tooltip>
      <div class="noAlert"></div>
    </div>
  </stats-card>
</template>
<script>
import { StatsCard } from "@/components/dashboard/index";
import AlertsDashboardTemplate from "@/components/AlertsDashboardTemplate.vue";
import moment from "moment";
export default {
  name: "AlertsSection",
  props: {
    snapshot: Object,
    detail: Array
  },
  components: {
    StatsCard,
    AlertsDashboardTemplate
  },
  methods: {
    formatterType(row) {
      if (row.dashboardCard == "promotion") {
        return this.i18nValues["promotion"];
      }
      if (row.dashboardCard == "collision") {
        return this.i18nValues["collision"];
      }
      if (row.dashboardCard == "delivery") {
        return this.i18nValues["distribution"];
      }
      if (row.dashboardCard == "forecast") {
        return this.i18nValues["forecast"];
      }
      if (row.dashboardCard == "typesPromos") {
        return this.i18nValues["typesOfPromotions"];
      }
      if (row.dashboardCard == "statusPos") {
        return this.i18nValues["posStatus"];
      }
      if (row.dashboardCard == "promoRanking") {
        return this.i18nValues["promotionsRanking"];
      }
      if (row.dashboardCard == "userRanking") {
        return this.i18nValues["userRanking"];
      }
      if (row.dashboardCard == "monitorPos") {
        return this.i18nValues["monitorPos"];
      }
      if (row.dashboardCard == "monitorBranch") {
        return this.i18nValues["monitorBranch"];
      }
    },
    formatDateHour: function(value) {
      let auxDate = moment(value.createTimestamp, "YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (auxDate.isValid()) return auxDate.format("DD/MM/YYYY HH:mm");
      else return undefined;
    }
  }
};
</script>
<style scoped>
.aling-between {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.btn-tooltip {
  border: 0px !important;
  background-color: white !important;
}
.btn-tooltip:hover,
.btn-tooltip:focus {
  background-color: white !important;
}
.btn-tooltip {
  font-size: 14px !important;
  padding: 0px 0px;
}
.text-grey {
  color: #a49e93 !important;
}
.noAlert {
  margin: 9px;
}
.p-10 {
  padding: 10px;
}
</style>